import React from 'react';
import benefitPoint from '../../image/benefit__point.png';
import './index.css';

const Personalize = () => {
  return (
    <section className="personalize">
      <div className="personalize__wrapper">
        <div className="personalize__content">
          <div className="personalize-content__wrapper">
            <h3 className="personalize-content__title">Personalized for you</h3>
            <p className="personalize-content__text">
              Stallion is a new standard in performance luxury 
              transport for the most ambitious and demanding clients. We offer a 
              unique comobination of services for personal transport and adventure. 
              The LaFerrari Aperta is the shit and we know you’ll love it.</p>
          </div>
        </div>
        <div className="personalize__benefits__wrapper">
          <ul className="personalize__benefits">
            <li className="personalize__benefit">
              <img src={benefitPoint} alt="Benefit Point"/>
              <h5>
                Business meetings
              </h5>
            </li>
            <li className="personalize__benefit">
              <img src={benefitPoint} alt="Benefit Point"/>
              <h5>
                Smash around town
              </h5>
            </li>
            <li className="personalize__benefit">
              <img src={benefitPoint} alt="Benefit Point"/>
              <h5>
                VIP socials &amp; events
              </h5>
            </li>
            <li className="personalize__benefit">
              <img src={benefitPoint} alt="Benefit Point"/>
              <h5>
                Low altitude ‘flying’
              </h5>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Personalize;
